import { render, staticRenderFns } from "./EmbeddedArticle.vue?vue&type=template&id=17cc0878&scoped=true&"
import script from "./EmbeddedArticle.vue?vue&type=script&lang=js&"
export * from "./EmbeddedArticle.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedArticle.vue?vue&type=style&index=0&id=17cc0878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc0878",
  null
  
)

export default component.exports